<template>
	<div class="map-bg bg-green-800 min-h-screen h-full w-full">
		<div style="position: relative; z-index: 1;">
			<div class="gradient-bg px-4 md:px-10 lg:px-32 xl:px-64 pt-6 pb-8">
				<h1 class="title text-white text-6xl sm:text-7xl md:text-8xl">LOST IN THE CITY</h1>
			</div>
			
			<div class="fixed bottom-0 left-0 w-full bottom-shadow">
				<error v-if="welcome_alert != null" class="px-4 md:px-10 lg:px-32 xl:px-64" colour="green" :icon="welcome_alert.icon" :title="welcome_alert.title" :body="welcome_alert.body" />
				
				<router-link to="/register">
					<div class="w-full bg-red-500 text-red-70 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
						GET EXPLORING
					</div>
				</router-link>
			</div>
		</div>
		
		<resetpassword v-if="show_password_reset" :recovery_key="recovery_key" />
	</div>
</template>

<style>
.gradient-bg {
	background: rgb(50,63,67);
	background: linear-gradient(180deg, rgba(50,63,67,1) 0%, rgba(50,63,67,1) 55%, rgba(50,63,67,0) 97%, rgba(50,63,67,0) 100%);
}
.title {
	line-height: 0.9;
	text-shadow: 0 3px 25px rgba(70, 83, 87, 0.6);
}
.bottom-shadow {
	box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.45);
}
</style>

<script>
import Storages from 'js-storage';
import ErrorBox from '../components/ErrorBox.vue';
import ResetPassword from '../components/ResetPassword.vue';

export default {
	name: 'Welcome',
	path: '/welcome',
	components: {
		'error': ErrorBox,
		'resetpassword': ResetPassword
	},
	data() {
		return {
			welcome_alert: null,
			show_password_reset: false,
			recovery_key: ""
		}
	},
	created() {
		this.storage = Storages.localStorage;
		
		if (this.$route.query.recovery_key) {
			this.recovery_key = this.$route.query.recovery_key;
			this.show_password_reset = true;
		} else if (this.storage.isSet('session_key')) {
			this.$router.push("/home");
			return;
		}
		
		this.welcome_alert = this.storage.get('welcome_alert');
	}
}
</script>
